import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useAuthUserStore } from "entities/auth/stores/authUserStore";
import { Message as TicketMessage } from "entities/customerTickets/types";
import React, { FC, Fragment } from "react";
import {
  COLOR_GREY_11,
  COLOR_GREY_12,
  COLOR_PRIMARY_MAIN,
  COLOR_WHITE,
} from "shared/theme/colors";
import { formatStringWithLink } from "shared/utils/formatStringWithLink";
import { urlRegex } from "shared/utils/regexPatterns/UrlRegex";
import SupportAvatar from "../../../../../../../SupportAvatar";
import { StyledMessage } from "../../styled";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import { getMessageDate } from "modules/customerTickets/pages/CustomerTickets/helpers";

type Props = {
  message: TicketMessage;
};

const SupportMessage: FC<Props> = ({ message }) => {
  const { selectedTicket } = useCustomerTicketsPage();
  const { firebaseUser } = useAuthUserStore();
  const userEmail = firebaseUser ? firebaseUser?.email || "" : undefined;

  if (!selectedTicket || !message) {
    return null;
  }

  const formattedMessage = formatStringWithLink(message.message);

  return (
    <>
      <Box display="flex" flexDirection="column" width="100%" rowGap="6px">
        <Box display="flex" justifyContent="space-between" width="100%">
          <Typography variant="bodyMSemiBold" color={COLOR_GREY_12}>
            Agent: {userEmail}
          </Typography>
          <Typography variant="bodySRegular" color={COLOR_GREY_11}>
            {message.timestamp && getMessageDate(message.timestamp.toDate())}
          </Typography>
        </Box>
        <StyledMessage isMessageFromUser={false} bgColor={COLOR_PRIMARY_MAIN}>
          <Typography variant="bodyMRegular" color={COLOR_WHITE}>
            {formattedMessage.map((message, idx) => {
              return (
                <Fragment key={idx}>
                  {message.match(urlRegex) ? (
                    <>
                      {" "}
                      <Link
                        href={message}
                        underline="always"
                        target="_blank"
                        rel="noreferrer"
                        color="#fff"
                      >
                        {message}
                      </Link>
                    </>
                  ) : (
                    message
                  )}
                </Fragment>
              );
            })}
          </Typography>
        </StyledMessage>
      </Box>
      <SupportAvatar />
    </>
  );
};

export default SupportMessage;
